import { ProductCategoriesPageProps } from '../../../types/app/categoriesTypes'
import { ProductCategoryRow } from './ProductCategoryRow';
import "./ProductCategories.scss"
import { LoadingItem } from '../../../shared/components/loading';
import CustomPagination from '../../../shared/components/pagination/CustomPagination';
import { useState } from 'react';
import { AddProductCategoryModal } from './AddProductCategoryModal';

interface Props {
    pageProps: ProductCategoriesPageProps;
    selected: number[];
    toggleSelect: (id: number) => void;
    searchValue: string;
    setSearchValue: (searchValue: string) => void;
    onSearch: (valus: string) => void;
    isSearchLoading: boolean;
    clearOrAllSelection: () => void;
    page: number;
    handlePageClick: (event: any) => void;
    handleDeleteCategory: (id: number) => void;
    handleCreateCategory: (payload: {
        name: string;
    }) => void;
    handleUpdateCategory: (payload: {
        name: string;
        id: number;
    }) => void
}

const ReportDisplay = ({ pageProps, selected, toggleSelect, searchValue, clearOrAllSelection, setSearchValue, onSearch, isSearchLoading, page, handlePageClick, handleDeleteCategory, handleCreateCategory , handleUpdateCategory}: Props) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <div className="categories-wrapper">
            <header className="categories-header">
                <h2>Product categories</h2>
                <span className="badge">{pageProps?.getProductCategoriesRequest?.request_data?.response?.totalNumberOfRecords}</span>
                <button className="new-category-btn" onClick={() => setShowModal(true)}> <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" >
                    <path d="M19 11H13V5h-2v6H5v2h6v6h2v-6h6z" />
                </svg> New Category</button>
            </header>

            <div className="table-controls">
                <div className="search-box">
                    <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="#BDBDBD"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round">
                        <path
                            d="M11 4a7 7 0 015.66 11.31l4.02 4.02-1.41 1.41-4.02-4.02A7 7 0 1111 4zm0 2a5 5 0 100 10 5 5 0 000-10z"
                            fill="#888"
                        />
                    </svg>
                    <input type="text" placeholder="Search inventory"
                        value={searchValue}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearchValue(e.target.value)
                            if (e.target.value === "") {
                                onSearch("")
                            }
                        }}
                        onKeyDown={(e: any) => {
                            if (e.key === 'Enter') {
                                onSearch(e.target.value.trim())
                            }
                        }} />
                </div>
                <button className="filter-btn">
                    Filter by

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="black"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="4" y1="6" x2="20" y2="6"></line>
                        <circle
                            cx="12"
                            cy="6"
                            r="2"
                            fill="white"
                            stroke="black"
                        ></circle>
                        <line x1="4" y1="12" x2="20" y2="12"></line>
                        <circle
                            cx="8"
                            cy="12"
                            r="2"
                            fill="white"
                            stroke="black"
                        ></circle>
                        <line x1="4" y1="18" x2="20" y2="18"></line>
                        <circle
                            cx="16"
                            cy="18"
                            r="2"
                            fill="white"
                            stroke="black"
                        ></circle>
                    </svg>
                </button>
            </div>

            <table className="categories-table">
                <thead>
                    <tr>
                        <th>
                            <label className="checkbox-container">
                                <input
                                    type="checkbox"
                                    checked={selected.length === pageProps?.getProductCategoriesRequest?.request_data?.response?.results?.length}
                                    onChange={(e) => clearOrAllSelection()}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Count</th>
                        <th>Created date</th>
                        <th></th>
                    </tr>
                </thead>
                {!isSearchLoading && pageProps?.getProductCategoriesRequest?.request_data?.response?.results.length !== 0 && !pageProps?.deleteProductCategoryRequest?.is_request_processing &&
                    <tbody>
                        {pageProps?.getProductCategoriesRequest?.request_data?.response?.results.map((cat) => (
                            <ProductCategoryRow key={cat.id} category={cat} selectedIds={selected} onSelect={toggleSelect} handleDeleteCategory={handleDeleteCategory} handleUpdateCategory={handleUpdateCategory}/>
                        ))}
                    </tbody>
                }
            </table>
            {(isSearchLoading || pageProps?.deleteProductCategoryRequest?.is_request_processing) &&
                <LoadingItem />
            }
            {pageProps?.getProductCategoriesRequest?.request_data?.response?.results.length === 0 &&
                <p className='not-found'>No Product Categories Found</p>
            }

            <div className="pagination-placeholder">
                {/* ReactPaginate goes here */}
                <CustomPagination
                    pageCount={pageProps?.getProductCategoriesRequest?.request_data?.response?.totalNumberOfPages}
                    forcePage={pageProps?.getProductCategoriesRequest?.request_data?.response?.pageNumber - 1}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={4}
                    renderOnZeroPageCount={null}
                    currentPageNumber={page}
                />
            </div>
            <AddProductCategoryModal show={showModal} onClose={() => setShowModal(false)} handleCreateCategory={handleCreateCategory} />
        </div>
    )
}

export default ReportDisplay